var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 27,
    viewBox: "0 0 35 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2374 10.8806H13.3545V16.1194H16.96L18.8152 21.7611H13.3545V26.9999H20.5378L26.7223 27L35 26.9999V21.7611H25.0387L23.2257 16.1194H35V10.8806H21.5422L19.7291 5.2388H35V0H13.3545L8.67667 6.07907e-05L0 27H6.13828L13.3381 5.10453L13.3545 5.15444V5.2388H13.3822L15.2374 10.8806ZM13.3822 5.2388H19.7291L18.0456 6.07907e-05L13.3545 0V5.15444L13.3822 5.2388ZM15.2374 10.8806L16.96 16.1194H23.2257L21.5422 10.8806H15.2374ZM25.0387 21.7611H18.8152L20.5378 26.9999L26.7223 27L25.0387 21.7611Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.fb4351ee6252f0a275738eec0210297b.svg";
export { ForwardRef as ReactComponent };